import React from 'react'
import Logo from '../images/logo.png' 

const Header = () => {
  return (
    <>
     <nav className="navbar navbar-expand-lg">
        <div className="container">
            <a className="navbar-brand" href="#">
            <img src={Logo} className="img-fluid" alt="Logo" />
             
            </a>

            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false"
                aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div classNameName="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <a href="#search" className="nav-link smoothScroll">eForm</a>
                    </li>
                    <li className="nav-item">
                        <a href="#project" className="nav-link smoothScroll">About</a>
                    </li>
                    <li className="nav-item">
                        <a href="blog.html" className="nav-link"></a>
                    </li>
                    <li className="nav-item">
                        <a href="#" className="nav-link contact">Contact</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    </>
  )
}

export default Header